<template>
  <div>
    <pn-table class="custom-responsive" :disabled="disabled" striped>
      <table>
        <tbody>
          <tr>
            <td>
              <div class="small bold grey">{{ $t('W2P_ORDER_NAME') }}</div>
              <div class="small details">{{ this.mailoutName }}</div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="small bold grey">{{ $t('SIZE') }}</div>
              <div class="small details">
                {{ $t(details.pageFormat.format) }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="small bold grey">{{ $t('W2P_PRINTING') }}</div>

              <div class="small details">
                {{ numberOfPages }} {{ $t('W2P_PAGES') }}
                {{ letterOptions.printType }}{{ $t('W2P_FULL_COLOR') }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="small bold grey">{{ $t('W2P_PAPER') }}</div>

              <div class="small details">
                {{ $t('W2P_LETTER_OPTIONS_DOUBLESIDED_PRINT_INFORMATION_1') }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="small bold grey">{{ $t('W2P_ENVELOPE') }}</div>

              <div class="small details">
                {{ $t('W2P_LETTER_OPTIONS_SINGLESIDED_PRINT_INFORMATION_2') }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="small bold grey">
                {{ $t('EDI_CREATE_PAGE_SENDER') }}
              </div>

              <div class="small details">
                <p>{{ this.sender.name }}</p>
                <p>{{ this.sender.address }}</p>
                <p>{{ this.sender.addressOptional }}</p>
                <p>{{ this.sender.postalCode }}</p>
                <p>{{ this.sender.city }}</p>
                <p>{{ this.sender.country }}</p>
              </div>
            </td>
          </tr>

          <tr v-if="contactInformation && contactInformation.companyName">
            <td>
              <div class="small bold grey">{{ $t('W2P_COMPANY') }}</div>

              <div class="small details">
                {{ contactInformation.companyName }}
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="small bold grey">{{ $t('W2P_RECIPIENTS') }}</div>

              <div class="small details">
                <p v-if="this.domestic > 0 && this.international > 0">
                  {{ this.domestic }} ({{ this.international }}
                  {{ $t('W2P_INTERNATIONAL_ADDRESSES') }})
                </p>

                <p v-else>
                  {{ this.domestic > 0 ? this.domestic : this.international }}
                </p>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div class="small bold grey">{{ $t('W2P_DELIVERY') }}</div>
              <div class="small details">
                <p
                  v-html="
                    $t('W2P_DELIVERY_APPROVE_DETAILS', {
                      formattedDate: format(this.deliveryDate, this.lang)
                    })
                  "
                ></p>
                <p
                  v-html="$t('W2P_LETTER_OPTIONS_COST_ESTIMATE_NOTE_TOOLTIP')"
                ></p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: null,
    editable: false,
    numberOfPages: 0,
    sender: null,
    domestic: Number,
    international: Number
  }),
  components: {},
  computed: {
    ...mapState('letter/cart', ['productDelivery']),
    ...mapState('letter/address', ['senderInformation', 'recipientsData']),
    ...mapState('letter/delivery', ['deliveryDate']),
    ...mapState('letter/pay', ['contactInformation']),
    ...mapState(['lang']),
    ...mapState('letter/upload', ['mailoutName', 'details', 'letterOptions'])
  },
  beforeMount() {
    this.options = JSON.parse(sessionStorage.getItem('letterOptions'))
    this.numberOfPages =
      this.$store.state['letter'].upload.details.numberOfPages.current || 0
    this.sender = this.senderInformation
    this.domestic = this.recipientsData[0] || 0
    this.international = this.recipientsData[1] || 0
    this.international += this.recipientsData[2] || 0
    this.international += this.recipientsData[3] || 0
  },
  methods: {
    makeEditable() {
      if (this.disabled) return
      this.editable = true
    },
    format(date, language) {
      moment.locale(language)
      return moment(date).format('LL')
    }
  }
}
</script>

<style lang="scss" scoped>
.grey {
  color: $black;
}

.details {
  color: $gray900;
  font-weight: 300;
}
</style>
